<template>
  <div>
    <div class="px-2 my-4">
      <h1 class="text-4xl font-extrabold tracking-tight text-gray-900">Suivi des ventes</h1>
    </div>
    <RetailAnalytics />
  </div>
</template>

<script>
import RetailAnalytics from "@/components/analytics/RetailAnalytics.vue";

export default {
  components: {
    RetailAnalytics,
  },
};
</script>
